export default __webpack_public_path__ + "static/instea-d79361d55eac03d58d1e865c336ba4ef.png";